import Vue from 'vue'

class BillingControlRepository {

  overview(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/financial/billing-control/overview',
        method: 'post',
        data,
      })
      .then(response => resolve(response.data))
      .catch(err => reject(err))
    })
  }

  forecast(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/financial/billing-control/forecast',
        method: 'post',
        data,
      })
      .then(response => resolve(response.data))
      .catch(err => reject(err))
    })
  }

  gaps(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/financial/billing-gaps',
        method: 'post',
        data,
      })
      .then(response => resolve(response.data))
      .catch(err => reject(err))
    })
  }

  gapDetail(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/financial/billing-gaps/detail',
        method: 'post',
        data,
      })
      .then(response => resolve(response.data))
      .catch(err => reject(err))
    })
  }

  revenueOpportunities(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/financial/revenue-opportunities',
        method: 'post',
        data,
      })
      .then(response => resolve(response.data))
      .catch(err => reject(err))
    })
  }

  exportGaps(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.download({
        url: '/api/financial/billing-gaps/export',
        method: 'post',
        data,
      })
      .then(response => resolve(response.data))
      .catch(err => reject(err))
    })
  }

  revenueCutoff(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/financial/revenue-cutoff',
        method: 'post',
        data,
      })
      .then(response => resolve(response.data))
      .catch(err => reject(err))
    })
  }

  revenueCutoffExport(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.download({
        url: '/api/financial/revenue-cutoff/export-xlsx',
        method: 'post',
        data,
      })
      .then(response => resolve(response.data))
      .catch(err => reject(err))
    })
  }

  revenueCutoffBreakdown(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/financial/revenue-cutoff/breakdown',
        method: 'post',
        data,
      })
      .then(response => resolve(response.data))
      .catch(err => reject(err))
    })
  }

}

export default new BillingControlRepository()
